import * as React from 'react';

import StatusMainGrid from '../../components/Dashboard/StatusMainGrid';

export default function Status(props) {
  return (
    <StatusMainGrid />
  );
}
